import { render, staticRenderFns } from "./AddComponentDialog.vue?vue&type=template&id=1c6c7ffe&scoped=true"
import script from "./AddComponentDialog.vue?vue&type=script&lang=js"
export * from "./AddComponentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddComponentDialog.vue?vue&type=style&index=0&id=1c6c7ffe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c7ffe",
  null
  
)

export default component.exports